import React from "react";
import Typography from "@material-ui/core/Typography";

export const HowToUseApp = ({ refProp }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>How to use Slotting App</u>
      </Typography>
      <p>
        The slotting application is a set of applications that help CA with the
        running of weekly missions. This includes several bots, webservices and
        databases.
      </p>
      <p>
        This next section will run through the basic steps on how to read a
        slotting post and how to reserve a space. As usual, if you have any
        issues understanding or using these applications, feel free to contact a
        Moderator or Officer.
      </p>
    </div>
  );
};

export default HowToUseApp;
